// API helpers for customer self-service profile edits.
// Auth lives in the httpOnly access_token cookie, sent automatically
// (axios.defaults.withCredentials = true, set in App.js).
import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// FastAPI returns two error shapes:
//   • Manual HTTPException → { detail: "string" }
//   • Pydantic validation  → { detail: [{ type, loc, msg, input, ctx, url }, ...] }
// React crashes if the array shape is rendered as a child (e.g. inside toast.error).
// This helper normalises both into a single readable string at the API boundary.
export function extractErrorMessage(err, fallback = 'Something went wrong') {
  const d = err?.response?.data?.detail;
  if (!d) return err?.message || fallback;
  if (typeof d === 'string') return d;
  if (Array.isArray(d)) {
    const first = d[0];
    if (first?.msg) {
      const field = Array.isArray(first.loc) ? first.loc[first.loc.length - 1] : null;
      return field ? `${field}: ${first.msg}` : first.msg;
    }
  }
  return fallback;
}

export async function updateProfileName(newName) {
  const { data } = await axios.patch(`${API}/me/profile`, { name: newName });
  return data; // { message, user }
}

export async function requestPhoneChange(newPhone) {
  const { data } = await axios.post(`${API}/me/phone/request-change`, { new_phone: newPhone });
  return data; // { message, email }
}

export async function resendPhoneChangeOtp() {
  const { data } = await axios.post(`${API}/me/phone/resend-otp`, {});
  return data; // { message, resend_count }
}

export async function verifyPhoneChange(otp) {
  const { data } = await axios.post(`${API}/me/phone/verify-change`, { otp });
  return data; // { message, user }
}
